import request from "@/utils/request";

export function getHubMeta() {
  return request({
    url: `/api/Hub/GetHub`,
    method: `get`,
  });
}

export function postHubMeta(params, data) {
  return request({
    url: `/api/Hub/SetHub`,
    method: `post`,
    data,
  });
}
